// A chunk's ground rectangle and the distance to it: shared by the view tier (streamer.ts, three.js) and the sim tier
// (residency.ts, plain data), so the sim tier never loads three.js.

/** A chunk's walkable rectangle on the ground plane (metres). */
export interface Area {
  x0: number;
  x1: number;
  z0: number;
  z1: number;
}

/** Distance (m) from (x, z) to the nearest point of `a`; 0 inside it. */
export function areaDistance(a: Area, x: number, z: number): number {
  const dx = Math.max(a.x0 - x, 0, x - a.x1);
  const dz = Math.max(a.z0 - z, 0, z - a.z1);
  return Math.hypot(dx, dz);
}
